export var DUAL_CARD = 'DUAL_CARD';
export var INSTALLMENT_LOAN = 'INSTALLMENT_LOAN';
export var INSTALLMENT_LOAN_MONTHLY = 'INSTALLMENT_LOAN_MONTHLY';
export var INSTALLMENT_LOAN_PAY_IN_FOUR = 'INSTALLMENT_LOAN_PAY_IN_FOUR';
export var WAIVED_INTEREST = 'WAIVED_INTEREST';
// conditions
export var OPEN = 'OPEN';
export var PRE_DELIVERY = 'PRE_DELIVERY';
export var CLOSED_WITH_BALANCE = 'CLOSED_WITH_BALANCE';
export var DELINQUENT = 'DELINQUENT';
export var AUTH_PROHIBITED = 'AUTH_PROHIBITED';
